import { Action } from '@ngrx/store';
import { AdvisorInformation } from 'src/app/models/entity';
import { IBankAccount } from 'src/app/models/investor';

export const LOAD_INVESTOR_BANK_ACCOUNT = '[Investor] Load Bank Account';
export const LOAD_INVESTOR_BANK_ACCOUNT_SUCCESS = '[Investor] Load Bank Account Success';
export const LOAD_INVESTOR_ENTITY = 'LOAD_INVESTOR_ENTITY';
export const LOAD_INVESTOR_ENTITY_SUCCESS = 'LOAD_INVESTOR_ENTITY_SUCCESS';
export const SAVE_INVESTOR_DETAILS = 'SAVE_INVESTOR_DETAILS';
export const SAVE_INVESTOR_DETAILS_SUCCESS = 'SAVE_INVESTOR_DETAILS_SUCCESS';
export const SAVE_INVESTOR_DETAILS_FAIL = 'SAVE_INVESTOR_DETAILS_FAIL';
export const RESET_TAX_DETAILS_FORM = 'RESET_TAX_DETAILS_FORM';
export const LOAD_INVESTOR_ADVISOR_INFORMATION = 'LOAD_INVESTOR_ADVISOR_DETAILS';
export const LOAD_INVESTOR_ADVISOR_DETAILS_SUCCESS = 'LOAD_INVESTOR_ADVISOR_DETAILS_SUCCESS';


export class LoadInvestorBankAccount implements Action {
    readonly type = LOAD_INVESTOR_BANK_ACCOUNT;
    constructor(public payload: any) { }
}
export class LoadInvestorBankAccountSuccess implements Action {
    readonly type = LOAD_INVESTOR_BANK_ACCOUNT_SUCCESS;
    constructor(public payload: IBankAccount[]) { }
}
export class LoadInvestorEntity implements Action {
    readonly type = LOAD_INVESTOR_ENTITY;
    constructor(public payload: any) { }
}
export class LoadInvestorEntitySuccess implements Action {
    readonly type = LOAD_INVESTOR_ENTITY_SUCCESS;
    constructor(public payload: any) { }
}
export class SaveInvestorDetails implements Action {
    readonly type = SAVE_INVESTOR_DETAILS;
    constructor(public payload: any) { }
}

export class SaveInvestorDetailsSuccess implements Action {
    readonly type = SAVE_INVESTOR_DETAILS_SUCCESS;
    constructor(public payload: any) { }
}

export class SaveInvestorDetailsFail implements Action {
    readonly type = SAVE_INVESTOR_DETAILS_FAIL;
    constructor(public payload: any) { }
}

export class ResetInvestorDetailsForm implements Action {
    readonly type = RESET_TAX_DETAILS_FORM;
}

export class LoadInvestorAdvisorInformation implements Action {
    readonly type = LOAD_INVESTOR_ADVISOR_INFORMATION;
    constructor(public payload: number[]) { }
}

export class LoadInvestorAdvisorInformationSuccess implements Action {
    readonly type = LOAD_INVESTOR_ADVISOR_DETAILS_SUCCESS;
    constructor(public payload: AdvisorInformation[]) { }
}

export type InvestorActions = LoadInvestorBankAccount | LoadInvestorBankAccountSuccess | 
            LoadInvestorEntity | LoadInvestorEntitySuccess | 
            SaveInvestorDetails | SaveInvestorDetailsSuccess | SaveInvestorDetailsFail | 
            ResetInvestorDetailsForm |
            LoadInvestorAdvisorInformation | LoadInvestorAdvisorInformationSuccess;
